/**
 * How many leads the trainer has not opened — the badge on the roster's „Zgłoszenia" button.
 *
 * `null` while unknown or after a failed read: the badge is then not drawn, never drawn as zero.
 */

import { useQuery } from '@tanstack/react-query';

import { newLeadsQueryOptions } from '../api/leadQueries';
import { newLeadCount } from '../model/leadStatus';

export function useNewLeadCount(): number | null {
  const first = useQuery(newLeadsQueryOptions());
  return first.data === undefined ? null : newLeadCount(first.data.items ?? []);
}
